// 必須項目表示の mixin

export default {
  props: {
    required: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    requiredClass: function () {
      const className = this.required ? 'required' : 'elective'

      const result = {}
      result[className] = true

      return result
    }
  }
}
